import { ResourceReservation } from '@/react/kubernetes/components/ResourceReservation';

import { ResourceQuotaFormValues } from './types';
import { useNamespaceResourceReservationData } from './useNamespaceResourceReservationData';

interface Props {
  namespaceName: string;
  environmentId: number;
  resourceQuotaValues: ResourceQuotaFormValues;
}

export function NamespaceResourceReservation({
  environmentId,
  namespaceName,
  resourceQuotaValues,
}: Props) {
  const {
    maxCPU,
    maxMemory,
    displayResourceUsage,
    resourceUsage,
    resourceReservation,
    isLoading,
  } = useNamespaceResourceReservationData(
    environmentId,
    namespaceName,
    resourceQuotaValues
  );

  if (!resourceQuotaValues.enabled) {
    return null;
  }

  return (
    <ResourceReservation
      title="Current resource reservations"
      displayResourceUsage={displayResourceUsage}
      resourceReservation={{
        cpu: resourceReservation.cpuRequest,
        memory: resourceReservation.memoryRequest,
      }}
      resourceUsage={resourceUsage}
      cpuLimit={maxCPU}
      memoryLimit={maxMemory}
      description="Resource reservation represents the total amount of resource assigned to all the applications deployed inside this namespace."
      isLoading={isLoading}
    />
  );
}
